import { render, staticRenderFns } from "./MotionHistoryDialog.vue?vue&type=template&id=12b40705&"
import script from "./MotionHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./MotionHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports